module.exports = __webpack_public_path__ + "img/pog_mekansm.7855d092.png";